import {
    AfterViewInit,
    ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Input, ViewChild,
} from '@angular/core';

import {GlobalAlertService} from '../global-alert.service';
import {ButtonCode, GlobalPopup} from '../global-popup';
import {HTTPError} from '../../../shared/services/http/http-error';
import {RequestFailure} from '../../../shared/services/http/request-failure';
import {FormDataService} from '../../../shared/components/form/services/form-data.service';
import {GlobalModel} from '../../../shared/services/state/global.model';
import {FormComponent} from '../../../shared/components/form/containers/form/form.component';
import {AuthorizationService} from '../../../shared/services/authorization/authorization.service';
import {TranslateService} from '../../../shared/services/translate/translate.service';
import {DefaultPopupWrapperComponent} from './default-popup-wrapper/default-popup-wrapper.component';
import {AbstractBasePopupComponent} from './abstract-base-popup.component';
import {TooltipService} from '../../../shared/services/tooltip/tooltip.service';
import { FormEvent } from '../../../shared/components/form/containers/form/form.interface';
import {LoggerService} from "../../../shared/services/logger/logger.service";

@Component({
    selector: 'global-popup-forza-mor-change-state-component',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        <default-popup-wrapper-component #wrapper [componentRef]="this"
                                         [disableButtonsOverride]="disableButtonsOverride" [globalPopup]="globalPopup"
                                         [showLoader]="isLoading" (onClose)="closePopup($event)">
            <ng-container *ngIf="formData && config">
                <form-component #form
                                [config]="config"
                                [name]="getFormName()"
                                [validationConstraints]="validationConstraints"
                                [invalidControlsErrors]="invalidControlsErrors"
                                [readOnly]="readOnly"
                                [formIsSubmitted]="formIsSubmitted"
                                (onComponentEvent)="handleComponentEvent($event)">
                </form-component>
            </ng-container>
        </default-popup-wrapper-component>
    `,
})
export class GlobalPopUpForzaMorChangeStateComponent extends AbstractBasePopupComponent implements AfterViewInit {
    private static readonly FORM_URL: string = 'report-malfunction/forza-mor/status/';

    @Input() statusCode: string = '';
    @Input() forzaMorAssetId: number = 0;

    @ViewChild('form', {static: false}) form: any;
    @ViewChild('wrapper', {static: false}) wrapper: DefaultPopupWrapperComponent;

    disableButtonsOverride: any = (button: any) => {
        return (this.config && this.config.disabled && (button.code !== ButtonCode.ANNULEREN)) ||
            (this.form && this.form.form && this.form.form.status === 'INVALID' && button.code !== ButtonCode.ANNULEREN);
    };

    public constructor(protected cd: ChangeDetectorRef, protected globalAlertService: GlobalAlertService,
                       private auth: AuthorizationService, protected formDataService: FormDataService,
                       protected elementRef: ElementRef, private model: GlobalModel,
                       protected ts: TranslateService, protected tooltipService: TooltipService, protected logger:LoggerService) {
        super(cd, globalAlertService, elementRef, ts, tooltipService, logger);
    }

    ngAfterViewInit() {

        // Retrieve map item id from the popup data
        this.statusCode = this.globalPopup.data.statusCode;
        this.forzaMorAssetId = this.globalPopup.data.forzaMorAssetId;

        let popupData: any = this.globalPopup.data;
        if (popupData && popupData.lat && popupData.lng) {
            this.model.formLocationComponentPosition = {lat: popupData.lat, lng: popupData.lng};
        }
        else {
            this.model.formLocationComponentPosition = null;
        }

        this.submitButton = this.getSubmitButton();

        this.requestFormData();
    }

    handlePopupAction(event: MouseEvent, alert: GlobalPopup, button: any): void {
        // callback for submit button comes from this form, not from outside this component
        if (button === this.submitButton) {
            this.form.handleComponentEvent({event: FormEvent.SAVE, data: {}});
            // this.form.submitForm();
        }
        else {
            // Hide alert and perform callback of button
            this.onPopupAction.emit({event: event, alert: alert, button: button});
        }
    }

    handleComponentEvent(eventData: any): void {

        if (eventData.event === FormEvent.SAVE) {
            this.submitFormData(eventData.data.formData);
        }
    }

    private submitFormData(form: any): void {
        if (this.forzaMorAssetId === 0) {
            this.logger.log('[GlobalAlertMoveItemComponent] ' + 'ERROR: trying to submit the form, but it is not linked to an item');
            return;
        }

        this.handleSubmitForm();

        this.formDataService.setFormData(form, this.getFormName(),
            GlobalPopUpForzaMorChangeStateComponent.FORM_URL + 'update/' + this.forzaMorAssetId + '/' + this.statusCode,
            (formData: any) => {
                // this.formData = formData;
                this.handleSubmitResponse();
                // Hide alert and perform success callback via submit button
                this.onPopupAction.emit({
                    event: null,
                    alert: this.globalPopup,
                    button: this.submitButton,
                    data: formData,
                });
            },
            (failure: RequestFailure) => {
                this.handleSubmitResponse(failure.formErrors);
            },
            (error: HTTPError) => {
                this.handleSubmitResponse(null, true);
            },
        );
    }

    closePopup(event: any): void {
        this.doDefaultCloseHandling(event, false);
    }

    public requestFormData(): void {
        this.formDataService.getFormData(
            GlobalPopUpForzaMorChangeStateComponent.FORM_URL + 'get/' + this.forzaMorAssetId + '/' + this.statusCode,
            (formData: any) => {

                // TODO: pas hier de latlng van de popup.data toe op de formData, als beschikbaar
                // En update dus de kaart en de locatie enzo

                // setTimeout(() => {
                this.formData = formData;
                this.isLoading = false;


                this.cd.detectChanges();
                this.wrapper.runChangeDetection();
                // });
            },
            () => {
                this.closePopup(null);
            },
            () => {
                this.closePopup(null);
            },
        );
    }
}
